function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2181.059,438.9c-.463,1.407-2.277,2.109-3.573,1.992a11.385,11.385,0,0,1-5.158-2.132,17,17,0,0,1-5.335-6.367,5.34,5.34,0,0,1,.219-5.538,2.114,2.114,0,0,1,1.69-.947c1.027-.051,1.172.537,1.524,1.454.263.684.614,1.383.81,2.093.367,1.326-.915,1.38-1.077,2.464-.1.683.726,1.6,1.1,2.086a10.12,10.12,0,0,0,2.607,2.4c.569.358,1.489,1.005,2.141.648,1-.549.908-2.243,2.313-1.67a22.959,22.959,0,0,1,2.125,1.1c1.072.578,1.022,1.175.613,2.417C2180.754,439.83,2181.365,437.974,2181.059,438.9Z",
  transform: "translate(-2166.329 -425.907)",
  fill: "#b40000"
});

var SvgCall = function SvgCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call.1897c5ff.svg";
export { ForwardRef as ReactComponent };